import { getId } from "./getId";

let musementIdCached;
export function getMusementId(): string {
  const musementId_Key = "musementId";
  return musementIdCached || (musementIdCached = getId(musementId_Key));
}

export function resetMusementId(): void {
  if (process.env["NODE_DEV"] == "test") {
    musementIdCached = null;
  }
}
